import { useContext } from 'react'
import { useTranslation } from 'react-i18next'
import ProductContext from '../context/ProductContext'

// Wholesale mode: the variant's line in the wholesale cart gets the form's quantity, so a variant already in the cart
// shows "Update", or "Added: N pcs" (disabled) while the form still has the cart quantity. `label` is null otherwise
// (retail mode, or not in the cart), when the buttons keep their usual labels.
const useWholesaleCartButton = (): { label: string | null; isAdded: boolean } => {
  const { t } = useTranslation()
  const { isWholesale, cartQuantity, formValues } = useContext(ProductContext)
  if (!isWholesale || !cartQuantity) return { label: null, isAdded: false }
  const isAdded = cartQuantity === formValues.quantity
  return {
    label: isAdded
      ? t('button.addedPcs', { defaultValue: 'Added: {{count}} pcs', count: cartQuantity })
      : t('button.update', 'Update'),
    isAdded,
  }
}

export default useWholesaleCartButton
